import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import {
  resetAllStationLoadingValuesReducer,
  setFibLibLoadingPercentageReducer,
  setFibLibValueReducer,
  setIsStationOptimizedReducer,
  updateBaseCPMReducer,
  updateBaseCPTReducer,
  updateDayLoadingPercentageReducer,
  updateDayTotalLoadingPercentageRecucer,
  updateNetworkBreakdownPercentageReducer,
  updatePeakLoadingReducer,
  updatePeakReducer,
  updateStationSelectedValueReducer,
  updateTotalCpmReducer,
  updateTotalCptReducer,
  updateTotalLoadingReducer,
  setAdMirroringLoadingReducer,
  toggleAdMirroringReducer
} from './calculatedReducer';

export const calculatedSlice = createSlice({
  name: 'calculated',
  initialState,
  reducers: {
    updateBaseCPM: updateBaseCPMReducer,
    updateBaseCPT: updateBaseCPTReducer,
    updatePeakLoading: updatePeakLoadingReducer,
    updateNetworkBreakdownPercentage: updateNetworkBreakdownPercentageReducer,
    updateDayLoadingPercentage: updateDayLoadingPercentageReducer,
    updateDayTotalLoadingPercentage: updateDayTotalLoadingPercentageRecucer,
    updatePeak: updatePeakReducer,
    updateTotalLoading: updateTotalLoadingReducer,
    updateTotalCpm: updateTotalCpmReducer,
    updateTotalCpt: updateTotalCptReducer,
    updateStationSelectedValue: updateStationSelectedValueReducer,
    resetAllStationLoadingValues: resetAllStationLoadingValuesReducer,
    setIsStationOptimized: setIsStationOptimizedReducer,
    setFibLibValue: setFibLibValueReducer,
    setFibLibLoadingPercentage: setFibLibLoadingPercentageReducer,
    setAdMirroringLoading: setAdMirroringLoadingReducer,
    toggleAdMirroring: toggleAdMirroringReducer
  }
});

export const {
  updateBaseCPM,
  updateBaseCPT,
  updatePeakLoading,
  updateNetworkBreakdownPercentage,
  updateDayLoadingPercentage,
  updateDayTotalLoadingPercentage,
  updatePeak,
  updateTotalLoading,
  updateTotalCpm,
  updateTotalCpt,
  updateStationSelectedValue,
  resetAllStationLoadingValues,
  setIsStationOptimized,
  setFibLibValue,
  setFibLibLoadingPercentage,
  setAdMirroringLoading,
  toggleAdMirroring
} = calculatedSlice.actions;

export default calculatedSlice.reducer;
